export default {
  users: [],
  isLoadingUsers: false,
  openFormForAdd: false,
  openFormForEdit: false,
  readOnly: false,
  userToEditSso: null,
  userToEdit: null,
  loggedInUser: null,
  userSettingsFormData: {
    businessUnits: [],
    companyCodes: [],
    connections: [],
    countries: [],
    availablePermissions: [],
    availableRoleAssignments: [],
    availableAssignmentPermissions: [],
    userClientList: [],
  },
  rolesAssignments: {},
  loadingRolesAssignmentsCount: 0,
  isSavingInProgress: false,
  isFetchingInitialDataForUserSettings: false,
  isUserModified: false,
  isEmailUnique: true,
  isPwcEmailSetup: false,
  isUserEmailUnderDomain: true,
  isSaveDialogVisible: false,
  isSSOUnique: true,
  isCheckingIfUsersSSOExists: false,
  isCheckingIfUsersEmailExists: false,
  isCheckingIfUserEmailUnderDomain: false,
};
